module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/opponent-jorge-masvidal-6.4884fba8.jpg";